/**
 * The tiny, dependency-free part of the marketplace OAuth flow that the app shell
 * needs at startup (index.tsx and the route table in App.tsx). Kept separate from
 * marketplaceOAuth.tsx on purpose: that module pulls in DatasourceService and the
 * OAuth services, which would otherwise ride along in the eager bundle.
 */

export const MARKETPLACE_OAUTH_CALLBACK_PATH = '/oauth2/callback';

/** OAuth providers redirect to /oauth2/callback(?/)?code=… but HashRouter routes live under #/… */
export const bootstrapMarketplaceOAuthCallbackRoute = (): void => {
	if (typeof window === 'undefined') {
		return;
	}

	const { pathname, search, hash } = window.location;
	const normalizedPath = (pathname || '/').replace(/\/+$/, '') || '/';
	if (normalizedPath !== MARKETPLACE_OAUTH_CALLBACK_PATH) {
		return;
	}

	if (hash.startsWith(`#${MARKETPLACE_OAUTH_CALLBACK_PATH}`)) {
		return;
	}

	window.location.replace(`${window.location.origin}/#${MARKETPLACE_OAUTH_CALLBACK_PATH}${search}`);
};
